import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQueryWithAuth } from './authBase.service'

export const affiliateApi = createApi({
    reducerPath: 'affiliate',
    baseQuery: baseQueryWithAuth,
    // Add tag types for cache invalidation
    tagTypes: ['Affiliate', 'Balance', 'Withdrawal'],
    // Configure cache behavior - ALWAYS refetch on mount/reload
    refetchOnMountOrArgChange: true, // ✅ TRUE = always refetch on mount (reload page)
    refetchOnFocus: true, // Refetch when window regains focus
    refetchOnReconnect: true, // Refetch when reconnecting
    endpoints: (builder) => ({
        getAffiliateInfo: builder.query({
            query: (params) => ({
                url: '/affiliates',
                method: 'GET',
                params
            }),
            // Keep cache for 60 seconds only
            keepUnusedDataFor: 60,
            // Tag for cache invalidation
            providesTags: ['Affiliate']
        }),
        getWithdrawal: builder.query({
            query: (params) => ({
                url: `/balance/withdraws`,
                method: 'GET',
                params
            }),
            keepUnusedDataFor: 60,
            providesTags: ['Withdrawal']
        }),
        getBalance: builder.query({
            query: () => ({
                url: `/balance`,
                method: 'GET',
            }),
            keepUnusedDataFor: 60,
            providesTags: ['Balance']
        })
    })
})

export const {
    useGetAffiliateInfoQuery,
    useGetWithdrawalQuery,
    useGetBalanceQuery,
    // Export utility functions for manual refetch/invalidation
    util: { invalidateTags, resetApiState }
} = affiliateApi